<script>

import ParallaxGradient from '@/components/ParallaxGradient';
import GlowGradient from '@/components/GlowGradient';
import VideoPlayer from '@/components/VideoPlayer';
import ProgramFilter from '@/components/ProgramFilter';
import ProgramFilterPanelButton from '@/components/ProgramFilterPanelButton';
import SocialFeed from '@/components/SocialFeed';
import Tingle from 'tingle.js';
import Fitty from 'fitty';


export default {
    name: 'WebContent',
    components: {
        ParallaxGradient,
        GlowGradient,
        VideoPlayer,
        ProgramFilter,
        ProgramFilterPanelButton,
        SocialFeed
    },
    data() {
        return {
            contentCollectionSlideIndex: 1,
            plusSlides: this.plusSlidesFunc,
        }
    },
    beforeDestroy() {

    },
    mounted() {
        

        var standalone = window.navigator.standalone,
            userAgent = window.navigator.userAgent.toLowerCase(),
            safari = /safari/.test( userAgent ),
            ios = /iphone|ipod|ipad/.test( userAgent ),
            body = document.getElementsByTagName("BODY")[0];

        if( ios ) {
            if ( !standalone && safari ) {
                //browser
            } else if ( standalone && !safari ) {
                //standalone
            } else if ( !standalone && !safari ) {
                 body.style.webkitTransform = 'translateZ(0)';
            };
        } else {
            //not iOS
        };
    

        
    },
    updated() {

    },
    methods: {
        tingle(options) { return new Tingle.modal(options) },
        fitty(options) { return new Fitty(options); },
       
        //simple function that uses XMLHttpRequest to get a url
        getHTML( url, callback ) {
            
            if ( !window.XMLHttpRequest ) return;       
            var xhr = new XMLHttpRequest();
        
            xhr.onload = function() {
                if ( callback && typeof( callback ) === 'function' ) {
                    callback( this.responseXML );
                }
            }
    
            xhr.open( 'GET', url );
            xhr.responseType = 'document';
            xhr.send();

        },
        

        
    },
};
</script>

<style
    lang="scss"
    src="../../scss/_liferay/web-content.scss"
></style>


// WEBPACK FOOTER //
// src/components/_liferay/WebContent.vue